import React, { useEffect, useState } from 'react';
import { Grid, Typography, CircularProgress } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { coloresEmma, obtenerValoresFiltros } from "../../global/js/funciones";

const useStyles = makeStyles((theme) => ({
    titulo: {
        paddingTop: '60px',
        [theme.breakpoints.down('sm')]: {
            textAlign: 'center'
        },
    },
    division: {
        height: '40px',
    },
    containerContenido: {
        maxWidth: 900,
        margin: '0 auto',
        padding: '20px',
    },
    texto: {
        fontSize: '16px',
        lineHeight: '24px',
        color: '#444',
    },
    tituloSeccion: {
        fontWeight: 'bold',
        fontSize: '17px',
        color: coloresEmma.primarycolor,
        marginBottom: 6,
    },
}));

export default function PoliticaPrivacidad() {
    const [background] = useState(coloresEmma.secondarycolor);
    const [politica, setPolitica] = useState([]);
    const [linkPolitica, setlinkPolitica] = useState('');
    const [cargar_politica, setCargarPolitica] = useState(true);

    const classes = useStyles();

    // 🔥 Fetch inicial (componentDidMount)
    useEffect(() => {
        const fetchData = async () => {
            try {
                let data = await obtenerValoresFiltros([
                    { llave: "generica", valor: 40 },
                    { llave: "estado", valor: 1 },
                ]);

                const ordenada = [...data].sort(
                    (a, b) => a.valorb - b.valorb
                );

                setPolitica(ordenada);
            } catch (error) {
                console.error(error);
            } finally {
                setCargarPolitica(false);
            }
        };

        fetchData();
    }, []);

    // 🔥 Obtener link documento
    useEffect(() => {
        const documento = politica.find(p => p.valora === 'DOCUMENTO');
        if (documento) {
            setlinkPolitica(documento.archivo);
        }
    }, [politica]);

    // 🔥 Render dinámico
    const textosPolitica = politica.map((text, index) => {
        if (text.valora === 'DOCUMENTO') return null;

        if (text.valora === 'TEXTO') {
            return (
                <div key={index} style={{ marginBottom: 12 }}>
                    <span className={classes.tituloSeccion}>
                        {text.nombre}:&nbsp;
                    </span>
                    <span className={classes.texto}>
                        {text.descripcion}
                    </span>
                </div>
            );
        }

        if (text.valora === 'LISTA') {
            return (
                <div key={index} style={{ marginBottom: 16 }}>
                    <div className={classes.tituloSeccion}>
                        {text.nombre}
                    </div>

                    {text.descripcion
                        ?.split(';')
                        ?.filter(e => e.trim() !== '')
                        ?.map((texto, i) => (
                            <div
                                key={i}
                                style={{
                                    display: 'flex',
                                    marginBottom: 6,
                                }}
                            >
                                <div
                                    style={{
                                        width: 6,
                                        height: 6,
                                        borderRadius: '50%',
                                        backgroundColor: '#000',
                                        marginTop: 8,
                                        marginRight: 10,
                                    }}
                                />
                                <div className={classes.texto}>
                                    {texto.trim()}
                                </div>
                            </div>
                        ))}
                </div>
            );
        }

        return null;
    });

    return (
        <div>
            {/* Header */}
            <Grid
                container
                justify="center"
                style={{ background: background, color: '#fff', padding: '60px 20px' }}
            >
                <Grid item xs={12} md={6} className={classes.titulo}>
                    <Typography variant="h4" style={{ letterSpacing: 4 }}>
                        POLÍTICA DE PRIVACIDAD
                    </Typography>
                    <Typography variant="body1" style={{ marginTop: 10 }}>
                        Conoce cómo recopilamos, usamos y protegemos tu información dentro de nuestra aplicación.
                    </Typography>
                </Grid>
            </Grid>

            {/* Contenido */}
            <div className={classes.containerContenido}>
                {cargar_politica ? (
                    <Grid container justify="center">
                        <CircularProgress />
                    </Grid>
                ) : (
                    <>
                        {textosPolitica}

                        {linkPolitica && (
                            <Typography
                                variant="body2"
                                style={{
                                    marginTop: 20,
                                    fontWeight: 600,
                                    color: coloresEmma.primarycolor,
                                    textDecoration: 'underline',
                                    cursor: 'pointer',
                                }}
                                onClick={() => window.open(linkPolitica, '_blank')}
                            >
                                Ver política de tratamiento de datos personales
                            </Typography>
                        )}
                    </>
                )}
            </div>
        </div>
    );
}